import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { RenderFormFields } from "src/components/RenderFormFields";
import { StepControls } from "../StepControls";
import { NAMES_FIELDS } from "../constants/fields";
import { registrationTitlesTrns } from "../trns";
import { StepControlsProps } from "../types";

interface Props extends StepControlsProps {}

export const ResponsiblePerson: FC<Props> = ({ ...stepControlsProps }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 md:gap-10">
        <h2 className="font-semibold">
          {t(registrationTitlesTrns.responsiblePerson)}
        </h2>

        <div className="flex flex-col justify-center items-center flex-1 gap-5 w-full lg:flex-row lg:gap-3">
          <RenderFormFields fields={NAMES_FIELDS} />
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
